var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZapperSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    height: 42,
    viewBox: "0 0 40 42",
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-50.892 -48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.226,59.41,77.723,48H56.881a5.781,5.781,0,0,0,0,11.562H67.226Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.671,89.943H56.532a5.716,5.716,0,0,1-5.171-3.3,5.416,5.416,0,0,1,1.065-6L81.02,49.9a5.8,5.8,0,0,1,8.061-.3,5.607,5.607,0,0,1,.3,7.95L69.46,78.693h15.21a5.738,5.738,0,0,1,5.78,5.7A5.613,5.613,0,0,1,84.671,89.943Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZapperSvg);
export default __webpack_public_path__ + "static/media/zapper-svg.41b93d2632103332343e0b8aa72e8997.svg";
export { ForwardRef as ReactComponent };